export enum DtwinMetadataStatus {
  ERROR,
  MIXED,
  SUCCESS,
  UNKNOWN,
}
